import { Hammer } from "lucide-react";
import React from "react";

function Disponible() {
  return (
    <div className="page-container max-w-4xl mx-auto my-12">
      <div className=" max-w-2xl mx-auto p-6 rounded-lg text-center mb-12">
        <h1 className="page-title text-5xl">Bientôt disponible !</h1>
        <p className="flex items-center justify-center text-6xl text-gray-400 mb-6">
          <Hammer size={200} />
        </p>
      </div>
    </div>
  );
}

export default Disponible;
